import React from 'react';
import { FaEnvelope, FaLinkedin, FaGithub } from 'react-icons/fa';

const links = [
    { icon: FaEnvelope, label: 'Email', href: 'mailto:taimanizar45@gmail.com' },
    { icon: FaLinkedin, label: 'LinkedIn', href: 'https://www.linkedin.com/in/taimahamadneh/' },
    { icon: FaGithub, label: 'GitHub', href: 'https://github.com/TaimaHamadneh' },
];

const Footer = () => (
    <footer className="border-t border-cream-200 bg-cream">
        <div className="container mx-auto flex flex-col items-center gap-4 px-4 py-6 text-sm text-gray-500 sm:flex-row sm:justify-between">
            <p>
                © {new Date().getFullYear()} <span className="font-semibold text-ink">Taima Hamadneh</span>
            </p>
            <ul className="flex items-center gap-2">
                {links.map(({ icon: Icon, label, href }) => (
                    <li key={label}>
                        <a
                            href={href}
                            aria-label={label}
                            {...(href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                            className="grid h-9 w-9 place-items-center rounded-full text-gray-500 transition hover:bg-pink-50 hover:text-pink-600"
                        >
                            <Icon aria-hidden="true" />
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    </footer>
);

export default Footer;
